import { Track } from '../../../classes/track'
import { TrackFields } from '../../../constants'

export const REGEX_KEY_PREFIX = `^\\d{1,2}[a,b,d,m]\\s?-?\\s+`

export function findTracksWithRegEx(tracks: Track[], regex: RegExp, field: string) {
  return tracks.filter(t => regex.test((t as any)[field] || ''))
}

export function regexReplace(track: any, values: any[]): string {
  const field: TrackFields = values[0]
  const regex: RegExp = values[1]
  const replaceString: string = values[2]

  let s: string = track[field]

  if (!s) s = ''

  return s.replace(regex, replaceString)
}
